/*
 * @deprecated
 * */
export const getRoute = <T extends string>(
  root: string,
  ...paths: T[]
): string => {
  return root.concat(...paths);
};

export const excludePath = (route: string, exclude: string): string => {
  return route.replace(exclude, '');
};

export const getPathWithoutParams = (path: string): string => {
  const arr = path.split('/');
  const arr_f = arr.filter(item => item && !item.startsWith(':'));
  return '/' + arr_f.join('/');
};
